import PaidInvoicesMainPage from "../components/PaidInvoices/PaidInvoicesMainPage";

const   PaidInvoicesPage = () => {
  return <PaidInvoicesMainPage />;
};

export default PaidInvoicesPage;
